// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/expired-modal.scss
// module id = 1225
// module chunks = 1 10 17